/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CombinedDecimalColumnZippedValues,
  CombinedStringColumnZippedValues,
  ProjectRigisHeader,
  ProjectRigisHeaderWithStat,
  RigisColumnZippedValues,
  RigisColumnsParameters,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectRigisClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Получение всех заголовков РИГИС в рамках заданного проекта.
   * @request GET:/geology/project/{projectId}/rigis/headers
   * @secure
   */
  projectRigisGetRigisHeadersForProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectRigisHeader[], any>({
      path: `/geology/project/${projectId}/rigis/headers`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Получение всех заголовков РИГИС с агрегатными полями в рамках заданного проекта.
   * @request GET:/geology/project/{projectId}/rigis/headers_with_stat
   * @secure
   */
  projectRigisGetRigisHeaderWithStat = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectRigisHeaderWithStat[], any>({
      path: `/geology/project/${projectId}/rigis/headers_with_stat`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Получение заголовков РИГИС в проекте по списку идентификаторов скважин.
   * @request POST:/geology/project/{projectId}/rigis/headers_by_wells
   * @secure
   */
  projectRigisGetRigisHeadersByWells = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectRigisHeader[], any>({
      path: `/geology/project/${projectId}/rigis/headers_by_wells`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Получение заголовков РИГИС в проекте по списку идентификаторов РИГИС.
   * @request POST:/geology/project/{projectId}/rigis/headers_by_ids
   * @secure
   */
  projectRigisGetRigisHeadersByIds = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectRigisHeader[], any>({
      path: `/geology/project/${projectId}/rigis/headers_by_ids`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Вернёт набор уникальных имён слоёв РИГИС для заданного проекта
   * @request GET:/geology/project/{projectId}/rigis/unique_layer_names
   * @secure
   */
  projectRigisGetUniqueLayerNames = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/rigis/unique_layer_names`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Вернёт набор уникальных имён прослоев РИГИС для заданного проекта
   * @request GET:/geology/project/{projectId}/rigis/unique_sublayer_names
   * @secure
   */
  projectRigisGetUniqueSublayerNames = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/rigis/unique_sublayer_names`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectRigis
 * @summary Основной быстрый метод чтения данных. 
По идентификаторам ригис и именам колонок вернёт сжатые значения, упорядоченные по глубине в соответствии с колонкой TopDepth.
Если данные по колонке ригис не пришли, значит их нет в БД.
Не следует отправлять запрос на весь проект целиком, иногда это слишком много данных.
 * @request POST:/geology/project/{projectId}/rigis/get_zipped_values
 * @secure
 */
  projectRigisGetZippedValues = (
    projectId: string,
    data: RigisColumnsParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<RigisColumnZippedValues[], any>({
      path: `/geology/project/${projectId}/rigis/get_zipped_values`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectRigis
 * @summary Метод чтения данных заданной колонки типа string или nullable string (например: Lithology, CurrentSaturation), 
объединяющий соседние слои с повторами значений в один толстый слой.
По идентификаторам ригис вернёт сжатые значения заданной колонки, глубин и толщин слоёв,
упорядоченные по глубине в соответствии с колонкой TopDepth. 
Возможные значения null пропускаются.
Если толщина слоя не достаёт до следующего, то слои не склеиваются.
 * @request POST:/geology/project/{projectId}/rigis/get_combined_string_values/{columnName}
 * @secure
 */
  projectRigisGetCombinedStringColumnValues = (
    projectId: string,
    columnName: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<CombinedStringColumnZippedValues[], any>({
      path: `/geology/project/${projectId}/rigis/get_combined_string_values/${columnName}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectRigis
 * @summary Метод чтения данных заданной колонки типа decimal или nullable decimal (например: Porosity, Permeability), 
объединяющий соседние слои с повторами значений в один толстый слой.
По идентификаторам ригис вернёт сжатые значения заданной колонки, глубин и толщин слоёв,
упорядоченные по глубине в соответствии с колонкой TopDepth. 
Возможные значения null пропускаются.
Если толщина слоя не достаёт до следующего, то слои не склеиваются.
 * @request POST:/geology/project/{projectId}/rigis/get_combined_decimal_values/{columnName}
 * @secure
 */
  projectRigisGetCombinedDecimalColumnValues = (
    projectId: string,
    columnName: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<CombinedDecimalColumnZippedValues[], any>({
      path: `/geology/project/${projectId}/rigis/get_combined_decimal_values/${columnName}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary По имени колонки РИГИС вернёт массив значений nullable-Boolean, упорядоченный по глубине в соответствии с колонкой TopDepth.
   * @request GET:/geology/project/{projectId}/rigis/{rigisId}/boolean_nullable/{columnName}
   * @secure
   */
  projectRigisGetColumnBooleanNullableValues = (
    projectId: string,
    rigisId: string,
    columnName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean[], any>({
      path: `/geology/project/${projectId}/rigis/${rigisId}/boolean_nullable/${columnName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary По имени колонки РИГИС вернёт массив значений nullable-Decimal, упорядоченный по глубине в соответствии с колонкой TopDepth.
   * @request GET:/geology/project/{projectId}/rigis/{rigisId}/decimal_nullable/{columnName}
   * @secure
   */
  projectRigisGetColumnDecimalNullableValues = (
    projectId: string,
    rigisId: string,
    columnName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<number[], any>({
      path: `/geology/project/${projectId}/rigis/${rigisId}/decimal_nullable/${columnName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary По имени колонки РИГИС вернёт массив значений Decimal, упорядоченный по глубине в соответствии с колонкой TopDepth.
   * @request GET:/geology/project/{projectId}/rigis/{rigisId}/decimal/{columnName}
   * @secure
   */
  projectRigisGetColumnDecimalValues = (
    projectId: string,
    rigisId: string,
    columnName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<number[], any>({
      path: `/geology/project/${projectId}/rigis/${rigisId}/decimal/${columnName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary По имени колонки РИГИС вернёт массив значений nullable-String, упорядоченный по глубине в соответствии с колонкой TopDepth.
   * @request GET:/geology/project/{projectId}/rigis/{rigisId}/string_nullable/{columnName}
   * @secure
   */
  projectRigisGetColumnStringNullableValues = (
    projectId: string,
    rigisId: string,
    columnName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/rigis/${rigisId}/string_nullable/${columnName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary По имени колонки РИГИС вернёт массив значений String, упорядоченный по глубине в соответствии с колонкой TopDepth.
   * @request GET:/geology/project/{projectId}/rigis/{rigisId}/string/{columnName}
   * @secure
   */
  projectRigisGetColumnStringValues = (
    projectId: string,
    rigisId: string,
    columnName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/rigis/${rigisId}/string/${columnName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectRigis
 * @summary Добавление РИГИС в проект из непроектных данных по списку идентификаторов РИГИС.
Сначала проверит и присоединит к проекту скважины, на которые ссылаются РИГИС.
По результатам уведимит о добавленных элементах.
 * @request POST:/geology/project/{projectId}/rigis
 * @secure
 */
  projectRigisAddRigisToProject = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/rigis`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectRigis
   * @summary Удалит РИГИС из проекта, не удаляя сами РИГИС из БД.
   * @request PATCH:/geology/project/{projectId}/rigis/remove
   * @secure
   */
  projectRigisRemoveRigisFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/rigis/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
